import { Button, FormControl } from "@mui/material";
import { CheckCircle, ArrowBack } from "@mui/icons-material";

const FormBottom = () => {
  return (
    <div className="w-full flex justify-end gap-4 mt-16">
      <FormControl>
        <Button
          startIcon={<ArrowBack />}
          size="small"
          type="button"
          href="/categories/0"
          fullWidth
          variant="contained"
          lang={"tr"}
        >
          Geri Dön
        </Button>
      </FormControl>
      <FormControl>
        <Button
          startIcon={<CheckCircle />}
          size="small"
          type="submit"
          fullWidth
          variant="contained"
          lang={"tr"}
        >
          Kaydet
        </Button>
      </FormControl>
    </div>
  );
};

export default FormBottom;
